import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  name: "statisticPeopleCounting",
  components: {newDatePicker: DatePicker},
  props:{
    height:{
      type:String,
      default:'100%',
    },
    maxHeight:{
      type:String,
      default:'100%',
    },
    domId:{
      type:String,
      default:'traffic_statistical'
    },
    //People Counting的统计类型 0：Reader Counting     1：Camera Counting
    operationType:{
      type:Number,
      default:0
    },
    //从那个地方点击进来的， 默认从watchList报表  0：表示从dashboard统计界面
    entrance:{
      type:Number,
      default:null,
    }
  },
  data(){
    let _this = this;
    return {
      /*People Counting 的统计*/
      monitoringAreaId:null,
      searchTimeList: [
        {type:0,name:'Date'},
        {type:1,name:'Week'},
        {type:2,name:'Month'},
      ],
      searchTimeInfo:{
        statisticType:0,
        startTime:'',
        endTime:'',
        isHourlyReport:true,
      },
      currentDay:'',
      option1:{
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        }
      },
      currentMonth:'',
      weekTime:'',
      lang: {
        formatLocale: {
          firstDayOfWeek: 1,
        },
      },
      handleWeek: {
        stringify:(date) =>{
          let dayseven = this.moment(date).startOf('isoWeek').format('YYYY');
          let week = this.moment(date).format('WW');
          return dayseven + '-' + week + ' week';
        },
        parse: (value) => {
          _this.changeWeek(value);
          return value ? this.moment(value, 'YYYY-WW').toDate() : null;
        },
        getWeek: (date) => {
          return this.moment(date).isoWeek();
        }
      },
      option2(date) {
        return date && date.valueOf() > Date.now();
      },
      trafficType:0,//统计类型 0：折线图     1:柱状图
      /*折线图*/
      trafficOption:{},
      trafficItem:[],
      trafficCount:[],
      myChart:null,
      isTrafficLoading:true,
      pieces:[],
      upperLimit:0,//上限
      reopenValue:0,//重开线的值
      currentValue:0,//设置折线图的max最大刻度线
    }
  },
  mounted(){

  },
  beforeDestroy(){
    if(this.myChart){
      this.myChart.off('click');
    };
  },
  methods:{
    // people counting 统计
    openTrafficStatistic:function(id){
      this.monitoringAreaId = id;
      if(!this.myChart){
        this.currentDay = this.moment().format(this.$root.Time[this.$root.Time.type].typeDateStr);
        this.searchTimeInfo = {
          id:this.monitoringAreaId,
          statisticType:0,
          startTime:this.common.formatDate(this.currentDay + '00:00:00', this.$root.Time[this.$root.Time.type].typeTime, 2),
          endTime:this.moment().valueOf(),
          isHourlyReport:true,
        };
        this.getTrafficDataByType();
      }
    },
    //查询折线图数据
    getStatisticData:function(){
      let _this = this;
      this.isTrafficLoading = true;
      this.myChart = null;
      this.$ajax.post('MonitoringArea/QueryStatisticData', _this.searchTimeInfo,  {headers:{noLoading:true}}).then(function (res) {
        _this.isTrafficLoading = false;
        if (res.data.success) {
          let result = res.data.data.items;
          _this.upperLimit = res.data.data.capacity || 0;
          //判断是否开启重开线
          _this.reopenValue = res.data.data.reOpeningThreshod ? res.data.data.reOpeningThreshodCount:0;
          //分段显示不同的颜色配置
          _this.pieces = []
          if(_this.reopenValue && _this.upperLimit && _this.reopenValue !== _this.upperLimit){
            _this.pieces = [
              {lte: _this.reopenValue, color: '#059FE8'},
              {gt: _this.reopenValue, lte: _this.upperLimit, color: '#FFCB3B'},
              {gt: _this.upperLimit, color: '#FF6868'},
            ]
          }else if((_this.upperLimit && !_this.reopenValue) || (_this.upperLimit && _this.reopenValue && _this.reopenValue === _this.upperLimit)){
            _this.pieces = [
              {gte:0 ,lte: _this.upperLimit, color: '#059FE8'},
              {gt: _this.upperLimit, color: '#FF6868'},
            ]
          }
          _this.trafficItem = result.map(item => {
            if(_this.searchTimeInfo.statisticType === 1){
              return _this.moment(item.key,_this.$root.Time[_this.$root.Time.type].typeDateStr).format('ddd')
            }else if(_this.searchTimeInfo.statisticType === 2){
              return _this.moment(item.key,_this.$root.Time[_this.$root.Time.type].typeDateStr).format('DD-MM')
            }else{
              return item.key;
            }
          });
          _this.currentValue = 0;
          _this.trafficCount = result.map(item => {
            if(item.value > _this.currentValue){
              _this.currentValue = item.value;
            }
            return {value:item.value, capacity:item.capacity, reOpeningThreshodCount:item.reOpeningThreshodCount, label:item.key};
          });
          _this.$nextTick(()=>{
            _this.initLineEchartsData();
          });
        } else {
          _this.messageNotice("error",res.data.message);
        }
      })
    },
    //查询柱状图的数据
    getUtilizationRate:function(){
      let _this = this;
      this.isTrafficLoading = true;
      this.myChart = null;
      this.pieces = [];
      this.$ajax.post('MonitoringArea/QueryUtilizationRate', _this.searchTimeInfo,  {headers:{noLoading:true}}).then(function (res) {
        _this.isTrafficLoading = false;
        if (res.data.success) {
          let result = res.data.data.items;
          _this.trafficItem = result.map(item => {
            if(_this.searchTimeInfo.statisticType === 1){
              return _this.moment(item.key,_this.$root.Time[_this.$root.Time.type].typeDateStr).format('ddd')
            }else if(_this.searchTimeInfo.statisticType === 2){
              return _this.moment(item.key,_this.$root.Time[_this.$root.Time.type].typeDateStr).format('DD-MM')
            }else{
              return item.key;
            }
          });
          _this.trafficCount = result.map(item => {
            return {value:item.value, capacity:item.capacity, reOpeningThreshodCount:item.reOpeningThreshodCount, label:item.key};
          });
          _this.$nextTick(()=>{
            _this.initBarEchartsData();
          });
        } else {
          _this.messageNotice("error",res.data.message);
        }
      })
    },
    //切换统计类型 0：折线图     1:柱状图
    changeTrafficType:function(index){
        this.trafficType = index;
        this.getTrafficDataByType(true);
    }, 
    //根据选择统计图的类型，调用不同接口
    getTrafficDataByType:function(flag){//flag是否为切换统计图类型的调用
      //判断选择的时间结束时间是不是以当前时间为结束时间
      if(flag){
        if(this.searchTimeInfo.statisticType === 0 && this.currentDay === (this.moment().format(this.$root.Time[this.$root.Time.type].typeDateStr))){
          this.searchTimeInfo.endTime = this.moment().valueOf();
        }else if(this.searchTimeInfo.statisticType === 1 && this.moment(this.weekTime, 'YYYY-WW').format('YYYY-WW') === this.moment().startOf('isoWeek').format('YYYY-WW')){
          this.searchTimeInfo.endTime = this.moment().valueOf();
        }else if(this.searchTimeInfo.statisticType === 2 && this.currentMonth === this.moment().format('MM-yyyy')){
          this.searchTimeInfo.endTime = this.moment().valueOf();
        }
      }
      if(this.trafficType === 0){
        this.getStatisticData();
      }else{
        this.getUtilizationRate(); 
      }
  },
    //切换天
    changeDate:function(date){
      let _this = this;
      //判断选择的时间是不是当天
      if(date === (_this.moment().format(_this.$root.Time[_this.$root.Time.type].typeDateStr))){
        _this.searchTimeInfo.startTime = _this.common.formatDate(date + '00:00:00', _this.$root.Time[_this.$root.Time.type].typeTime, 2);
        _this.searchTimeInfo.endTime = _this.moment().valueOf();
      }else{
        _this.searchTimeInfo.startTime = _this.common.formatDate(date + '00:00:00', _this.$root.Time[_this.$root.Time.type].typeTime, 2);
        _this.searchTimeInfo.endTime = _this.common.formatDate(date + '23:59:59', _this.$root.Time[_this.$root.Time.type].typeTime, 2);
      }
      console.log('change day');
      _this.getTrafficDataByType();
    },
    //切换周
    changeWeek:function(date){
      let _this = this;
      if(_this.moment(date, 'YYYY-WW').format('YYYY-WW') === _this.moment().startOf('isoWeek').format('YYYY-WW')){
        _this.searchTimeInfo.startTime = _this.moment().startOf('isoWeek').valueOf();
        _this.searchTimeInfo.endTime = _this.moment().valueOf();
      }else{
        _this.searchTimeInfo.startTime = _this.moment(date, 'YYYY-WW').startOf('isoWeek').valueOf();
        _this.searchTimeInfo.endTime = _this.moment(date, 'YYYY-WW').endOf('isoWeek').valueOf();
      }
      console.log('change week');
      _this.getTrafficDataByType();
    },
    //切换月
    changeMonth:function(month){
      let _this = this;
      if(month === _this.moment().format('MM-yyyy')){
        _this.searchTimeInfo.startTime = _this.moment(month,'MM-yyyy').valueOf();
        _this.searchTimeInfo.endTime = _this.moment().valueOf();
      }else{
        _this.searchTimeInfo.startTime = _this.moment(month,'MM-yyyy').valueOf();
        _this.searchTimeInfo.endTime = _this.moment(month,'MM-yyyy').endOf('month').valueOf()
      }
      console.log('change month');
      _this.getTrafficDataByType();
    },
    changeSearchTimeType:function(type){
      let _this = this;
      _this.searchTimeInfo.statisticType = type;
      //根据时间进行统计
      switch (type){
        case 0:
          _this.currentDay = _this.moment().format(_this.$root.Time[_this.$root.Time.type].typeDateStr);
          _this.searchTimeInfo.startTime = _this.common.formatDate(_this.currentDay + '00:00:00', _this.$root.Time[_this.$root.Time.type].typeTime, 2);
          _this.searchTimeInfo.endTime = _this.moment().valueOf();
          _this.searchTimeInfo.isHourlyReport = true;
          _this.getTrafficDataByType();
          break;
        case 1:
          _this.weekTime = _this.moment().startOf('isoWeek').format('YYYY-WW') + ' week';
          _this.searchTimeInfo.isHourlyReport = false;
          break;
        case 2:
          _this.currentMonth = _this.moment().format('MM-yyyy');
          _this.searchTimeInfo.startTime = _this.moment(_this.currentMonth,'MM-yyyy').valueOf();
          _this.searchTimeInfo.endTime = _this.moment().valueOf();
          _this.searchTimeInfo.isHourlyReport = false;
          _this.getTrafficDataByType();
          break;
        default:
          break;
      }
    },
    generatePeopleCounting:function(){
      let type = this.trafficType === 0 ? 56:68;
      this.$emit('generateReport',{type:type, id:this.monitoringAreaId});
    },
    /****************折线图*********************/
    initLineEchartsData:function(){
      let _this = this;
      let chartDom = document.getElementById(this.domId);
      this.myChart = _this.$echarts.init(chartDom);
      this.trafficOption = {
        color:['#059FE8','#FFCB3B','#FF6868'],
        grid: {
          top: '30px',
          left: '6px',
          right: '60px',
          bottom: '0',
          containLabel: true
        },
        tooltip: {/*鼠标移入显示效果*/
          trigger: 'axis',
          axisPointer:{
            type:'line',
            lineStyle:{
              color:'#059FE8',
            },
          },
          backgroundColor:'rgba(255,255,255,1)',
          extraCssText:'box-shadow: 0px 0px 6px 2px rgba(0,0,0,0.16);',
          padding: [12,16,12,16],
          textStyle:{
            color:'#333',
          },
          formatter: function (params) {
            let param = params[0];
            let aboveCapacity = (param.data.value - _this.upperLimit) > 0 ? (param.data.value - _this.upperLimit):0;
            let str = '';
            if(_this.reopenValue){
              let occupancyCapacity = _this.reopenValue;
              let aboveControlledLimit = param.data.value > _this.upperLimit ? (_this.upperLimit - _this.reopenValue < 0 ? 0: _this.upperLimit - param.data.reOpeningThreshodCount)
              :(param.data.value - _this.reopenValue < 0 ? 0:param.data.value - _this.reopenValue);
              str = ''
                +'<div style="display: flex;justify-content: space-between;width: 240px">'
                  + '<span><span style="display:inline-block;width:8px;height:8px;border-radius: 4px;background:#317CC5;margin-right:8px"></span>Occupancy Limit:</span>'
                  + '<span>'+ occupancyCapacity +'</span>'
                + '</div> '
                + '<div style="display: flex;justify-content: space-between;width: 240px">'
                  + '<span><span style="display:inline-block;width:8px;height:8px;border-radius: 4px;background:#FFCB3B;margin-right:8px"></span>Warning Line:</span>'
                  + '<span>'+ aboveControlledLimit +'</span>'
                + '</div> ';
            }else{
              let occupancyCapacity = (param.data.value > _this.upperLimit) ? _this.upperLimit:param.data.value;
              str = '<div style="display: flex;justify-content: space-between;width: 240px">'
                + '<span><span style="display:inline-block;width:8px;height:8px;border-radius: 4px;background:#317CC5;margin-right:8px"></span>Occupancy Limit:</span>'
                + '<span>'+ occupancyCapacity +'</span>'
                + '</div> '
            }
            let title = _this.searchTimeInfo.statisticType === 0 ? _this.moment(_this.currentDay,_this.$root.Time[_this.$root.Time.type].typeDateStr).format('DD-MM') + ' ' + param.name
                      : _this.searchTimeInfo.statisticType === 2 ?  param.data.label:param.name;
            let htmlStr = ''
              + '<div>' + title + '<br/>'
                + '<div style="display: flex;justify-content: space-between;width: 240px">'
                  + '<span style="font-weight: bold">Highest Count:</span>'
                  + '<span><span style="font-weight: bold">'+ param.data.value +'</span>/'+ _this.upperLimit +'</span>'
                + '</div>'
                + '<div style="display: flex;justify-content: space-between;width: 240px">'
                  + '<span>Occupancy Ratio:</span>'
                  + '<span>'+ Number((param.data.value/_this.upperLimit * 100).toFixed(1)) +'%</span>'
                + '</div> '
                //分割线
                + '<div style="height:1px;margin:8px 0;border: 1px solid #f3f3f3;"></div>'
                + str
                + '<div style="display: flex;justify-content: space-between;width: 240px">'
                  + '<span><span style="display:inline-block;width:8px;height:8px;border-radius: 4px;background:#FF6868;margin-right:8px"></span>Over Capacity:</span>'
                  + '<span>'+ aboveCapacity +'</span>'
                + '</div> '
              + '</div>';
            return htmlStr;
          }
        },
        xAxis: {
          name: _this.searchTimeInfo.statisticType === 0 ? 'Time': _this.searchTimeInfo.statisticType === 1 ? 'Week':'Month',
          type: 'category',
          nameTextStyle:{
            color:'#999',
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#999',//坐标线的颜色
            }
          },
          axisLabel: {
            textStyle: {
              color: '#333',//坐标值得具体的颜色
            }
          },
          data: _this.trafficItem,
        },
        yAxis: { 
          name: 'No.',
          type: 'value',
          minInterval: 1,//_this.upperLimit +以上限设置最小值的原因是上限值可能大于实际的数据值，导致看不到上限的标记线
          min: 0,
          /*1.如果重开线比实际值最大值还大10，那么就以实际最大值加10来加定义为重开线和最大刻度值。
          2.如果重开线小于实际最大值，那么就以实际最大值为最大刻度线。
          3.如果重开线大于实际最大值，但是不超过10，那么以重开线的值作为最大刻度值
          */
          max: _this.upperLimit - _this.currentValue > 10 ? _this.currentValue + 10: _this.upperLimit < _this.currentValue ? _this.currentValue:_this.upperLimit,
          axisLine:{ // 是否显示坐标线
            show:true,
            lineStyle: {
              type: 'solid',
              color: '#999',//坐标线的颜色
            }
          },
          axisLabel: {
            textStyle: {
              color: '#333',//坐标值得具体的颜色
            },
            formatter: function (value, index) {
              if(_this.upperLimit - _this.currentValue > 10 && value === _this.currentValue + 10){
                return _this.upperLimit;
              }else{
                return value;
              }
            }
          },
        },
        visualMap: [],
        series: [
          {
            data: _this.trafficCount,
            type: 'line',
            itemStyle:{
              normal:{
                color:'#059FE8',
              },
            },
            emphasis:{
              scale:5,//鼠标移入原点的放大倍数
            } ,
            //上限的标记线
            markLine: { 
              silent:true,
              symbol : [ 'none', 'none' ],//去掉箭头
              lineStyle : {
                  normal : {
                      color : 'rgba(190,27,27,.3)',
                      type : 'solid',
                      width : 2
                      // 这儿设置安全基线颜色
                  }
              },
              //根据实际的最大值和上限值作对比，为了更好呈现折线图的效果，当实际值与上限值差很多时，用假的标记线来表示上限值
              data : [
                  {
                      yAxis : _this.upperLimit - _this.currentValue > 10 ? parseInt(_this.currentValue + 10):parseInt(_this.upperLimit),
                      name: _this.upperLimit + '',
                  }
              ],
              label : {
                  normal : {
                      textStyle : {
                          color : 'rgba(190,27,27,1)',
                      },
                      formatter :function (param) {
                        return param.name;
                      }
                  },
              },
            },

          },
        
        ]
      };
      if(_this.pieces.length > 0) {
        this.trafficOption.visualMap.push(
          {
            show: false,
            seriesIndex: 0, //指定取哪个系列的数据，即哪个系列的 series.data。默认取所有系列。
            pieces: _this.pieces,
          }
        );
      }
      this.myChart.setOption(this.trafficOption);
      //当统计的是某周或者某月可点击统计图直接看某天的数据
      this.myChart.off('click');
      this.myChart.on('click', function(params) {
        if(params.componentType === 'series' && params.value > 0 && _this.searchTimeInfo.statisticType > 0){ 
          _this.searchTimeInfo.statisticType = 0;
          _this.currentDay = params.data.label;
          _this.changeDate(_this.currentDay);
        }
      });
    },
    //柱状图
    initBarEchartsData: function(){
      let _this = this;
      let chartDom = document.getElementById(this.domId);
      this.myChart = _this.$echarts.init(chartDom);
      this.trafficOption = {
        tooltip: {
          trigger: "item",
          backgroundColor:'#fff',
          borderColor:'#059FE8',
          borderWidth:1,
          textStyle:{
            color:'#333',
            fontSize:'14'
          },
          formatter: function (param) {
            let title = _this.searchTimeInfo.statisticType === 0 ? _this.moment(_this.currentDay,_this.$root.Time[_this.$root.Time.type].typeDateStr).format('DD-MM') + ' ' + param.name
                      : _this.searchTimeInfo.statisticType === 2 ?  param.data.label:param.name;
            return "<div>" + title + "</div>" + 
            "<div><span>Total: " + param.value + "</span></div>"
          }
        },
        grid: {
          top: '30px',
          left: '6px',
          right: '60px',
          bottom: '0',
          containLabel: true
        },
        xAxis: {
          name: _this.searchTimeInfo.statisticType === 0 ? 'Time': _this.searchTimeInfo.statisticType === 1 ? 'Week':'Month',
          type: 'category',
          nameTextStyle:{
            color:'#999',
          },
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              type: 'solid',
              color: '#999',//坐标线的颜色
            }
          },
          axisLabel: {
            textStyle: {
              color: '#333',//坐标值得具体的颜色
            }
          },
          data: _this.trafficItem,
        },
        yAxis: {
          name: 'No.',
          type: 'value',
          minInterval:1,
          axisLine:{ // 是否显示坐标线
            show:true,
            lineStyle: {
              type: 'solid',
              color: '#999',//坐标线的颜色
            }
          },
          axisLabel: {
            textStyle: {
              color: '#333',//坐标值得具体的颜色
            }
          },
        },
        visualMap: [],
        series: [
          {
            name: "",
            type: "bar",
            barWidth: 30,
            barGap: "100%",
            itemStyle: {
              opacity: 0.1,
              normal: {
                show: true,
                barBorderRadius: 0,
                borderWidth: 0,
                color: '#059FE8',
                label: {
                  show: true,		//开启显示
                  position: 'top',	//在上方显示
                  textStyle: {	    //数值样式
                    color: '#333',
                    fontSize: 14,
                  }
                },
              },
            },
            data: this.trafficCount,
          },
        ],
      }
      this.myChart.setOption(this.trafficOption);
      //当统计的是某周或者某月可点击统计图直接看某天的数据
      this.myChart.off('click');
      this.myChart.on('click', function(params) {
        if(params.componentType === 'series' && params.value > 0 && _this.searchTimeInfo.statisticType > 0){ 
          _this.searchTimeInfo.statisticType = 0;
          _this.currentDay = params.data.label;
          _this.changeDate(_this.currentDay);
        }
      });
    },
  },
}



// WEBPACK FOOTER //
// ./src/admin/components/commonComponents/statisticPeopleCounting.js